import get from 'lodash/get';
import { useCallback, useEffect } from 'react';
import { browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { PAPERWORK_QUERY_PARAMS } from '../helpers/queryParams';
import { getAppointmentId } from '../../../utils/paperwork';
import { selectAuthLoggedInStatus } from '../../../redux/auth/selectors';
import { selectPaperworkAppointmentSessionError } from '../../../redux/paperwork/selectors/paperwork-appointment-session';
import { actions as paperworkAppointmentSessionActions } from '../../../redux/paperwork/requests/paperwork-appointment-session';

const useHandleAutoAuthenticate = query => {
  const dispatch = useDispatch();

  const appointmentUUID = getAppointmentId();

  const isLoggedIn = useSelector(selectAuthLoggedInStatus);

  const appointmentSessionError = useSelector(
    selectPaperworkAppointmentSessionError,
  );

  const removeQueryParam = useCallback(() => {
    const location = browserHistory.getCurrentLocation();

    const newQuery = { ...query };

    const authToken = get(query, PAPERWORK_QUERY_PARAMS.AUTH_TOKEN);

    if (authToken) {
      delete newQuery[PAPERWORK_QUERY_PARAMS.AUTH_TOKEN];
      dispatch(paperworkAppointmentSessionActions.clear());
    }

    browserHistory.replace({
      pathname: location.pathname,
      query: newQuery,
    });
  }, [query]);

  useEffect(() => {
    const authToken = get(query, PAPERWORK_QUERY_PARAMS.AUTH_TOKEN);

    if (authToken && !isLoggedIn) {
      dispatch(
        paperworkAppointmentSessionActions.send({
          authToken,
          appointmentUUID,
        }),
      );
    }
  }, [query, isLoggedIn, appointmentUUID]);

  useEffect(() => {
    if (appointmentSessionError) {
      removeQueryParam();
    }
  }, [appointmentSessionError]);
};

export default useHandleAutoAuthenticate;



// WEBPACK FOOTER //
// ./src/components/Paperwork/hooks/useHandleAutoAuthenticate.js